import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Typography } from "@mui/material";
import { useSelector } from 'react-redux';
import { LocalizationProvider, DateCalendar } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs"
const Roznamcha = () => {
    const [payments, setPayments] = useState([]);
    const [otherPayments, setOtherPayments] = useState([]);
    const api = useSelector((state) => state.Api);
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const initialRoz = useRef(false)
    useEffect(() => {
        fetchPayments();
    }, []);

    const fetchPayments = async (date) => {
        const fetchDate = date; 
        if(initialRoz.current) return
        initialRoz.current = true
        const userToken = JSON.parse(localStorage.getItem("User_Data"))?.token || undefined;
        try {
            const response = await axios.post(api.showRoznamcha,  {selectedDate: fetchDate},   {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${userToken}`,
                },
            });
            if (response.status === 200) {
                //console.log(response.data)
                setPayments(response.data.today_payments);
                setOtherPayments(response.data.till_yesterday)
            }
        } catch (err) {
            console.error("Error fetching suppliers:", err);
        }
        // try {
        //     const response = await axios.get(api.showRoznamcha);
        //     //console.log(response.data)
        //     setPayments(response.data.today_payments);
        //     setOtherPayments(response.data.till_yesterday)
        // } catch (error) {
        //     console.error("Error fetching payments:", error);
        // }
    };

    let cumulativeIn = otherPayments?.balance;
    let cumulativeOut = 0;

    // Function to handle date selection
    const handleDateChange = (date) => {
        initialRoz.current = false
        setSelectedDate(date);
        // //console.log("Selected Date:", date.format("YYYY-MM-DD"));
        fetchPayments(date)
    };

    return (
        <TableContainer component={Paper} style={{ marginTop: "20px", marginBottom: '30px' }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateCalendar
                value={selectedDate}
                onChange={handleDateChange}
                views={["year", "month", "day"]}
                shouldDisableDate={(date) => dayjs(date).isAfter(dayjs(), 'day')} // Disable future dates
            />
        </LocalizationProvider>
                
            <Table style={{marginBottom: '10px'}}>
                <TableHead>
                    <TableRow>
                        <TableCell colSpan={2} style={{ width:"50%", textAlign: "center", fontWeight: "bold", fontSize: "22px", backgroundColor: "rgb(255 233 206)" }}>بورد ګی</TableCell>
                        <TableCell colSpan={2} style={{ width:"50%", textAlign: "center", fontWeight: "bold", fontSize: "22px", backgroundColor: "#dff0d8" }}>امد</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        {/* <TableCell sx={{ fontWeight: 'bold', fontSize: '16px', padding: '4px', backgroundColor: "rgb(255 233 206)" }}>مجموعه</TableCell> */}
                        <TableCell sx={{ fontWeight: 'bold', fontSize: '16px', padding: '4px', backgroundColor: "rgb(255 233 206)" }}>بوردګی </TableCell>
                        <TableCell sx={{ fontWeight: 'bold', fontSize: '16px', padding: '4px', backgroundColor: "rgb(255 233 206)" }}>تفصیل</TableCell>
                        {/* <TableCell sx={{ fontWeight: 'bold', fontSize: '16px', padding: '4px', backgroundColor: "#dff0d8" }}>مجموعه</TableCell> */}
                        <TableCell sx={{ fontWeight: 'bold', fontSize: '16px', padding: '4px', backgroundColor: "#dff0d8" }}>امد </TableCell>
                        <TableCell sx={{ fontWeight: 'bold' , fontSize: '16px', padding: '4px', backgroundColor: "#dff0d8"}}>تفصیل</TableCell>
                    </TableRow>
                    {/* <TableRow>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell sx={{ fontWeight: 'bold', fontSize: '16px', padding: '4px' }}>{otherPayments?.balance?.toFixed(2)}</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', fontSize: '16px', padding: '4px' }}>{otherPayments?.balance?.toFixed(2)}</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' , fontSize: '16px', padding: '4px'}}>د پرون بیلانس</TableCell>
                    </TableRow> */}
                    {payments?.map((payment, index) => {
                        cumulativeIn +=  payment.amount_in || 0;
                        cumulativeOut += payment.amount_out || 0;
                        return (
                            <TableRow key={index}>
                                {/* Outgoing */}
                                {/* <TableCell sx={{ padding: "4px" }}>{payment.amount_out ? cumulativeOut?.toFixed(2) : ""}</TableCell> */}
                                <TableCell sx={{ padding: "4px" }}>{payment.amount_out ? payment?.amount_out?.toFixed(2) : ""}</TableCell>
                                <TableCell sx={{ padding: "4px" }}>{payment.amount_out ? payment.description : ""}</TableCell>

                                {/* Incoming */}
                                {/* <TableCell sx={{ padding: "4px" }}>{payment.amount_in ? cumulativeIn.toFixed(2) : ""}</TableCell> */}
                                <TableCell sx={{ padding: "4px" }}>{payment.amount_in ? payment?.amount_in?.toFixed(2) : ""}</TableCell>
                                <TableCell sx={{ padding: "4px" }}>{payment.amount_in ? payment.description : ""}</TableCell>
                            </TableRow>
                        );
                    })}
                    <TableRow>
                        <TableCell sx={{ padding: "4px", fontWeight: 'bold' }}>{cumulativeOut?.toFixed(2)}</TableCell>
                        <TableCell sx={{ padding: "4px", fontWeight: 'bold', fontSize: '16px' }} colSpan={1}>ټوټل بورد ګی</TableCell> 

                        <TableCell sx={{ padding: "4px", fontWeight: 'bold' }}>{cumulativeIn?.toFixed(2)}</TableCell>
                        <TableCell sx={{ padding: "4px", fontWeight: 'bold', fontSize: '16px' }} colSpan={2}>ټوټل امد</TableCell> 
                    </TableRow>
                    <TableRow> 
                        <TableCell  sx={{ padding: "4px", fontWeight: 'bold' }}></TableCell>
                     
                        <TableCell  sx={{ padding: "4px", fontWeight: 'bold' }}></TableCell>
                        <TableCell style={{fontSize: '16px', fontWeight:'bold', padding: '4px', textAlign:'left'}}>{(cumulativeIn - cumulativeOut)?.toFixed(2)}  : دنن دخل </TableCell> 
                        <TableCell style={{fontSize: '16px', fontWeight:'bold', padding: '4px', textAlign:'center'}}>{(  otherPayments?.balance)?.toFixed(2)}  : دپرون دخل </TableCell> 
                    </TableRow>
                    <TableRow> 
                        {/* <TableCell colSpan={2}  sx={{ padding: "4px", fontWeight: 'bold' }}></TableCell> */}
                        <TableCell colSpan={4} style={{fontSize: '20px', fontWeight:'bold', padding: '30px 4px 10px 4px', textAlign:'center'}}>{((cumulativeIn - cumulativeOut) + otherPayments?.balance)?.toFixed(2)}  : مجموعه دخل </TableCell> 
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default Roznamcha;
